import React from 'react';
import { motion } from 'framer-motion';
import { FaBriefcase, FaGraduationCap } from 'react-icons/fa';
import './Experience.css';

const Experience = () => {
  const experiences = [
   {
  type: 'work',
  title: 'Java Full Stack Developer',
  company: 'Disrupting – CBRE',
  period: 'July 2024 – Present',
  description: 'Design and development of scalable microservices using Java 21 and Spring Boot. Implementation of secure RESTful APIs with Keycloak SSO, PostgreSQL on Azure, CI/CD with Azure DevOps, Docker-based environments, and modern frontend development with React and Next.js.',
  technologies: ['Java 21', 'Spring Boot', 'Spring Cloud', 'React', 'Next.js', 'PostgreSQL', 'Azure', 'Docker', 'Keycloak', 'Swagger', 'JUnit', 'Azure DevOps']
},
{
  type: 'work',
  title: 'Java Full Stack Developer',
  company: 'Disrupting – ASP SEGUROS',
  period: 'Aug 2023 – July 2024',
  description: 'Development and maintenance of REST APIs using Java 8 and Spring Framework. Database optimization and migration with PostgreSQL, MySQL, and Talend. Frontend development with XHTML and PrimeFaces, applying clean code principles and Scrum methodology.',
  technologies: ['Java 8', 'Spring Framework', 'Spring Security', 'PostgreSQL', 'MySQL', 'Talend', 'PrimeFaces', 'WildFly', 'GitLab']
},
{
  type: 'work',
  title: 'Mid-Level Java Full Stack Developer',
  company: 'Ari Group – BANORTE',
  period: 'Sept 2022 – July 2023',
  description: 'Development of microservices and batch processes using Java 11 and Spring Boot. Frontend development with Angular and Bootstrap. Database management with Oracle, HANA, and MySQL, focusing on performance optimization and large data processing.',
  technologies: ['Java 11', 'Spring Boot', 'Spring Batch', 'Angular', 'Oracle', 'HANA', 'MySQL', 'WebSphere', 'SVN']
},
{
  type: 'work',
  title: 'Freelance Developer & Network Engineer',
  company: 'Instituto Tecnológico de Acapulco',
  period: 'Jan 2022 – July 2022',
  description: 'Designed and implemented a high-speed point-to-point wireless network using Ubiquiti technology, achieving stable 250 Mbps connectivity. Led network configuration, optimization, and infrastructure management.',
  technologies: ['Ubiquiti', 'Networking', 'DNS', 'IP Configuration', 'Wireless Infrastructure']
},
{
  type: 'work',
  title: 'Junior Java Developer',
  company: 'Telephone Systems and Services',
  period: 'July 2021 – Dec 2021',
  description: 'Development and maintenance of web applications using Java and JavaScript. Network configuration and infrastructure support for private and public sector clients.',
  technologies: ['Java', 'JavaScript', 'HTML', 'CSS', 'Bootstrap', 'Networking']
},
{
  type: 'education',
  title: 'Bachelor’s Degree in Computer Systems Engineering',
  company: 'Instituto Tecnológico de Acapulco',
  period: '2016 – 2020',
  description: 'Focused on software development, distributed systems architecture, algorithms, and database design.',
  technologies: ['Java', 'MySQL','Algorithms', 'Data Structures', 'Databases', 'Software Engineering', 'HTML', 'CSS']
}

  ];

  return (
    <section id="experience" className="section experience">
      <div className="container">
        <motion.h2 
          className="section-title gradient-text"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Experience & Education
        </motion.h2>

        <div className="timeline">
          {experiences.map((exp, idx) => (
            <motion.div 
              key={idx}
              className="timeline-item"
              initial={{ opacity: 0, x: idx % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.2, duration: 0.5 }}
            >
              <div className={`timeline-content ${exp.type}`}>
                <div className="timeline-icon">
                  {exp.type === 'work' ? <FaBriefcase /> : <FaGraduationCap />}
                </div>
                
                <div className="timeline-card">
                  <span className="timeline-period">{exp.period}</span>
                  <h3 className="timeline-title">{exp.title}</h3>
                  <h4 className="timeline-company">{exp.company}</h4>
                  <p className="timeline-description">{exp.description}</p>
                  
                  <div className="timeline-tech">
                    {exp.technologies.map((tech, techIdx) => (
                      <span key={techIdx} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
